import { useContext } from "react";
import { SearchValueContext } from "contexts/searchContext";

export default function useSearchValue() {
  return useContext(SearchValueContext);
}
